import { useEffect, useState } from "react";
import AdminTopbar from "../../component/AdminTopbar";
import { ChevronRight, Edit3, Filter, Settings, Trash } from "react-feather";
import { baseurl, imageUrl } from "../../Baseurl";
import axios from "axios";
import AddProjectManagement from "../../component/AddProjectManagement";
import AddAssignee from "../../component/AddAssignee";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NavbarDashboard from "../../component/NavbarDashboard";
import SuperSideBar from "./Compo/SuperSideBar";

function SuperDashboard() {
  const [viewMode, setViewMode] = useState("card");

  const [projects, setProjects] = useState([]);
  const [searchLabel, setSearchLabel] = useState("");
  const [filterPriority, setFilterPriority] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filterAssignee, setFilterAssignee] = useState("");

  const adminID = localStorage.getItem("adminID");

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await axios.get(`${baseurl}getAllProjectManagementDetails/${adminID}`);
        if (res.data && res.data.projects) {
          setProjects(res.data.projects);
        }
      } catch (error) {
        console.error("Failed to fetch project data:", error);
      }
    };

    fetchProjects();
  }, []);

  const handleDeleteProject = async (projectId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This project will be permanently deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`${baseurl}deleteProject/${projectId}`);
        setProjects((prev) => prev.filter((p) => p.id !== projectId));
        toast.success("Project deleted successfully!");
      } catch (error) {
        console.error("Failed to delete project:", error);
        toast.error("Failed to delete project!");
      }
    }
  };

  const filteredProjects = projects.filter((project) => {
    const matchesLabel = project.labels.toLowerCase().includes(searchLabel.toLowerCase());
    const matchesPriority = filterPriority ? project.priority === filterPriority : true;

    const plannedDate = new Date(project.planned_date);
    const matchesDate =
      (!startDate || plannedDate >= new Date(startDate)) &&
      (!endDate || plannedDate <= new Date(endDate));

    const matchesAssignee = filterAssignee
      ? project.assignees.some((a) =>
          a.full_name.toLowerCase().includes(filterAssignee.toLowerCase())
        )
      : true;

    return matchesLabel && matchesPriority && matchesDate && matchesAssignee;
  });

  return (
    <>
      <div className="App" style={{ display: "flex" }}>

<SuperSideBar/>

        <div className="superwidth" style={{ flexGrow: 1, padding: "0px" }}>
      
         
          <div className="px-4">
            <div className="container-fluid">
              <div className="crdmain mb-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h2 className="chart-title text-start">Projects Board</h2>
                    <p>List of your ongoing projects</p>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="me-3 d-flex align-items-center">
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => setViewMode(viewMode === "card" ? "table" : "card")}
                      >
                        {viewMode === "card" ? "Switch to Table View" : "Switch to Card View"}
                      </button>
                    </div>
                    <div className="me-3">
                      <AddProjectManagement />
                    </div>
                    <div>
                      <AddAssignee />
                    </div>
                  </div>
                </div>

                <div className="row my-3 g-1">
                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      className="form-control form-control-filter"
                      placeholder="Search by Label"
                      value={searchLabel}
                      onChange={(e) => setSearchLabel(e.target.value)}
                    />
                  </div>

                  <div className="col-md-2 mb-2">
                    <select
                      className="form-select form-control-filter"
                      value={filterPriority}
                      onChange={(e) => setFilterPriority(e.target.value)}
                    >
                      <option value="">All Priorities</option>
                      <option value="Low">Low</option>
                      <option value="Medium">Medium</option>
                      <option value="High">High</option>
                    </select>
                  </div>

                  <div className="col-md-2 mb-2">
                    <input
                      type="date"
                      className="form-control form-control-filter"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>

                  <div className="col-md-2 mb-2">
                    <input
                      type="date"
                      className="form-control form-control-filter"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>

                  <div className="col-md-2 mb-2">
                    <input
                      type="text"
                      className="form-control form-control-filter"
                      placeholder="Filter by Assignee"
                      value={filterAssignee}
                      onChange={(e) => setFilterAssignee(e.target.value)}
                    />
                  </div>

                  <div className="col-md-1 mb-2">
                    <button
                      className="custom-btn blue"
                      onClick={() => {
                        setSearchLabel("");
                        setFilterPriority("");
                        setStartDate("");
                        setEndDate("");
                        setFilterAssignee("");
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </div>

                <div className="row g-4 mt-0 mb-0 text-start op2 pb-3">
                  {viewMode === "card" ? (
                    <div className="row g-4 mt-0 mb-0 text-start op2 pb-3">
                      {filteredProjects.map((project, index) => (
                        <div className="col-md-3" key={project.id || index}>
                          <Link to={`/project/${project.id}`}>
                            <div className="project-card" style={{ backgroundColor: "#f0f0f0" }}>
                              <div className="project-header">
                                <img
                                  src={
                                    project.file_name
                                      ? `${imageUrl}project/${project.file_name}`
                                      : "https://via.placeholder.com/150"
                                  }
                                  alt="Project"
                                  className="project-image"
                                />
                                <span className="project-date">
                                  {new Date(project.planned_date).toLocaleDateString()}
                                </span>
                              </div>
                              <div className="project-info">
                                <h4 className="project-title">{project.labels}</h4>
                                <p className="project-subtitle">{project.priority || "N/A"}</p>
                              </div>
                              <div>
                                <div className="avatars mb-3 ms-2">
                                  {project.assignees.map((member, index) => (
                                    <img
                                      key={index}
                                      src={
                                        member.profile_image
                                          ? `${imageUrl}assignee/${member.profile_image}`
                                          : "https://via.placeholder.com/40"
                                      }
                                      alt={member.full_name}
                                      title={member.full_name}
                                      className="avatar"
                                    />
                                  ))}
                                </div>
                                <div className="d-flex justify-content-between">
                                  <div className="deadline" style={{ backgroundColor: "#ffc107" }}>
                                    {project.actual_completion_date
                                      ? new Date(project.actual_completion_date).toLocaleDateString()
                                      : "No deadline"}
                                  </div>
                                  <button
                                    className="custom-btn red"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleDeleteProject(project.id);
                                    }}
                                    title="Delete Project"
                                  >
                                    <Trash size={16} />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="table-responsive mt-3">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th>Image</th>
                            <th>Label</th>
                            <th>Priority</th>
                            <th>Planned Date</th>
                            <th>Completion Date</th>
                            <th>Assignees</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredProjects.map((project, index) => (
                            <tr key={index}>
                              <td>
                                <img
                                  src={
                                    project.file_name
                                      ? `${imageUrl}project/${project.file_name}`
                                      : "https://via.placeholder.com/50"
                                  }
                                  alt="Project"
                                  width={50}
                                />
                              </td>
                              <td>
                                <Link to={`/project/${project.id}`}>{project.labels}</Link>
                              </td>
                              <td>{project.priority || "N/A"}</td>
                              <td>{new Date(project.planned_date).toLocaleDateString()}</td>
                              <td>
                                {project.actual_completion_date
                                  ? new Date(project.actual_completion_date).toLocaleDateString()
                                  : "N/A"}
                              </td>
                              <td>
                                {project.assignees.map((member, index) => (
                                  <img
                                    key={index}
                                    src={
                                      member.profile_image
                                        ? `${imageUrl}assignee/${member.profile_image}`
                                        : "https://via.placeholder.com/40"
                                    }
                                    alt={member.full_name}
                                    title={member.full_name}
                                    className="avatar"
                                  />
                                ))}
                              </td>
                              <td>
                                <button
                                  className="custom-btn red me-2"
                                  onClick={() => handleDeleteProject(project.id)}
                                  title="Delete Project"
                                >
                                  <Trash size={16} />
                                </button>

                                <Link to={`/project/${project.id}`} className="custom-btn blue py-2"><Edit3 size={16} /></Link>

                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </div>
    </>
  );
}

export default SuperDashboard;
